import * as C from "io-ts/Codec";
import * as Arr from "fp-ts/Array";
import * as D from "io-ts/Decoder";
import { pipe } from "fp-ts/function";
import * as En from "io-ts/Encoder";

export const searchParamArray = <I, O, A>(d: C.Codec<unknown, O, A>) =>
  C.make(D.union(pipe(d, D.map(Arr.of)), D.array(d)), En.array(d));
